export const WISHLIST_KEY = "wishlist";
